import React from 'react';

import { Box, Collapse, TableCell, TableRow } from '@mui/material';

import { dropdownContentSx, getDropdownCellSx } from './campaignScheduleTabLayout';

interface DropdownRowProps {
  children: React.ReactNode;
  colSpan: number;
  isExpanded: boolean;
}

export function CampaignScheduleDropdownRow({ children, colSpan, isExpanded }: DropdownRowProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={getDropdownCellSx(isExpanded)}>
        <Collapse unmountOnExit in={isExpanded} sx={{ width: '100%' }} timeout="auto">
          <Box sx={dropdownContentSx}>{children}</Box>
        </Collapse>
      </TableCell>
    </TableRow>
  );
}
